import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9d4b7654"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "data ws_mr5" }
const _hoisted_2 = { class: "dialog-footer" }

import { ref, watch, computed } from 'vue'
import {
  queryUserUpdate,
  queryUserAdd,
  queryUserOrg,
  queryRoleList,
  queryUserDetail,
  queryRoleTreeList,
  queryOrgTreeList,
} from '@/api'
import type { FormInstance } from 'element-plus'
import { CODE_ENUM } from '@/common/enum'
import { ElMessage } from 'element-plus'
import { passwordReg, phoneReg, accountReg } from '@/common/regexp'
import { isEmpty } from 'lodash'
import { encode } from '@/utils'
import i18n from '@/i18n'


export default /*#__PURE__*/_defineComponent({
  __name: 'user-modal',
  props: ['visible', 'data'],
  emits: ['update:visible', 'success'],
  setup(__props, { emit: $emit }) {

const props = __props;

const t = i18n.global.t




watch(
  () => props.visible,
  () => {
    if (props.visible) {
      queryOrg()
      queryRole()
      if (props.data.userId) {
        queryDetail()
      }
      if (props.data.orgId) {
        formData.value.orgId = props.data.orgId
      }
    }
  }
)

const disbaledRuleChange = computed(() => {
  return !!props.data.userId
})

const formData = ref({
  username: '',
  nickname: '',
  orgId: '',
  password: '',
  confirmPassword: '',
  email: '',
  mobile: '',
  // isSaveAlarmContact: [],
  roleId: '',
})

const cancel = () => {
  $emit('update:visible', false)
  formRef.value.resetFields()
}

const detailLoading = ref(false)
const queryDetail = async () => {
  detailLoading.value = true
  const res: any = await queryUserDetail({
    userId: props.data.userId,
  }).finally(() => {
    detailLoading.value = false
  })
  if (res?.code === CODE_ENUM.SUCCESS) {
    formData.value = {
      ...formData.value,
      ...res.data,
    }
  }
}

const vailidateMethod = (reg: RegExp, msg: string) => {
  return (rule: any, value: any, callback: any) => {
    if (reg.test(value)) {
      callback()
    } else {
      callback(msg)
    }
  }
}

const validatorComfirPassword = (rule: any, value: any, callback: any) => {
  if (value === formData.value.password) {
    callback()
  } else {
    callback(t('CONFIG.comfirmMsg'))
  }
}

const rules: any = {
  username: [
    { required: true, message: t('CONFIG.msgEnter') },
    {
      validator: vailidateMethod(accountReg, t('CONFIG.msgAccound')),
    },
  ],
  nickname: [{ required: true, message: t('CONFIG.msgEnter') }],
  orgId: [{ required: true, message: t('CONFIG.msgSelect') }],
  password: [
    { required: true, message: t('CONFIG.msgEnter') },
    {
      validator: vailidateMethod(passwordReg, '6-30位字符串'),
    },
  ],
  confirmPassword: [
    { required: true, message: t('CONFIG.msgEnter') },
    {
      validator: validatorComfirPassword,
    },
  ],
  roleId: [{ required: true, message: t('CONFIG.msgSelect') }],
  email: [
    { required: true, message: t('CONFIG.msgEnter') },
    {
      type: 'email',
      message: t('CONFIG.msgEmail'),
    },
  ],
  mobile: [
    { required: true, message: t('CONFIG.msgEnter') },
    {
      validator: vailidateMethod(phoneReg, t('CONFIG.msgMobile')),
    },
  ],
}

const loading = ref(false)
const formRef: any = ref<FormInstance>()

const handleAddDevice = () => {
  formRef.value.validate(async (valid: boolean) => {
    if (valid) {
      loading.value = true
      const isSaveAlarmContact = 0
      const fn = props.data.userId ? queryUserUpdate : queryUserAdd
      const res: any = await fn({
        ...formData.value,
        userId: props.data.userId,
        isSaveAlarmContact,
        // isSaveAlarmContact: isEmpty(formData.value.isSaveAlarmContact) ? 0 : 1,
        password: props.data.userId
          ? undefined
          : encode(formData.value.password),
      }).finally(() => {
        loading.value = false
      })
      if (res?.code === CODE_ENUM.SUCCESS) {
        ElMessage({
          message: props.data.userId
            ? t('CONFIG.editSuccess')
            : t('CONFIG.newSuccess'),
          type: 'success',
        })
        cancel()
        $emit('success')
      } else {
        ElMessage({
          message: res?.msg,
          type: 'error',
        })
      }
    }
  })
}

const deepFormat = (
  list: any,
  level = 0,
  topOrgName = '-',
  parentOrgId?: any
) => {
  if (isEmpty(list)) {
    return
  }
  return list.map((item: any) => {
    const { children, id, name, ...p } = item
    return {
      ...p,
      name,
      value: id,
      id,
      label: name,
      children: deepFormat(children, level + 1, name, id),
      level: level + 1,
      topOrgName,
      parentOrgId,
      class: 'node_' + id,
    }
  })
}

const orgList: any = ref([])
const queryOrg = async () => {
  const res: any = await queryOrgTreeList()
  if (res?.code === CODE_ENUM.SUCCESS) {
    const result = deepFormat([res.data])

    orgList.value = result
  }
}

const roleList: any = ref([])
const queryRole = async () => {
  const res: any = await queryRoleTreeList()
  if (res?.code === CODE_ENUM.SUCCESS) {
    roleList.value = (res.data || []).map((item: any) => {
      // 不能新建超管
      return {
        label: item.name,
        value: item.id,
        disabled: item.isSuperAdmin,
      }
    })
  }
}

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_tree_select = _resolveComponent("el-tree-select")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    "model-value": props.visible,
    title: props.data.userId ? _ctx.$t('CONFIG.editTitle') : _ctx.$t('CONFIG.newTitle'),
    class: "config-config-user",
    width: "500px",
    "before-close": cancel
  }, {
    footer: _withCtx(() => [
      _createElementVNode("span", _hoisted_2, [
        _createVNode(_component_el_button, {
          plain: "",
          onClick: cancel
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('CONFIG.btnCancel')), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          loading: loading.value,
          type: "primary",
          onClick: handleAddDevice
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('CONFIG.btnYes')), 1)
          ]),
          _: 1
        }, 8, ["loading"])
      ])
    ]),
    default: _withCtx(() => [
      _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_el_form, {
          model: formData.value,
          rules: rules,
          ref_key: "formRef",
          ref: formRef,
          "label-position": "left",
          "label-width": "120"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              prop: "username",
              label: _ctx.$t('CONFIG.labelUserName')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: formData.value.username,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.username) = $event)),
                  maxlength: "20",
                  placeholder: _ctx.$t('CONFIG.userNamePla'),
                  disabled: !!props.data.userId
                }, null, 8, ["modelValue", "placeholder", "disabled"])
              ]),
              _: 1
            }, 8, ["label"]),
            (!props.data.userId)
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 0,
                  prop: "password",
                  label: _ctx.$t('CONFIG.labelPassword')
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: formData.value.password,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.password) = $event)),
                      maxlength: "50",
                      placeholder: _ctx.$t('CONFIG.passwordPla'),
                      type: "password",
                      "show-password": ""
                    }, null, 8, ["modelValue", "placeholder"])
                  ]),
                  _: 1
                }, 8, ["label"]))
              : _createCommentVNode("", true),
            (!props.data.userId)
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 1,
                  prop: "confirmPassword",
                  label: _ctx.$t('CONFIG.labelComfirmPassword')
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: formData.value.confirmPassword,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.value.confirmPassword) = $event)),
                      maxlength: "50",
                      placeholder: _ctx.$t('CONFIG.comfirmPasswordPla'),
                      type: "password",
                      "show-password": ""
                    }, null, 8, ["modelValue", "placeholder"])
                  ]),
                  _: 1
                }, 8, ["label"]))
              : _createCommentVNode("", true),
            _createVNode(_component_el_form_item, {
              prop: "nickname",
              label: _ctx.$t('CONFIG.labelNickName')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: formData.value.nickname,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formData.value.nickname) = $event)),
                  maxlength: "50",
                  placeholder: _ctx.$t('CONFIG.nicknamePla')
                }, null, 8, ["modelValue", "placeholder"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, {
              prop: "mobile",
              label: _ctx.$t('CONFIG.labelMobile')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: formData.value.mobile,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formData.value.mobile) = $event)),
                  maxlength: "20",
                  placeholder: _ctx.$t('CONFIG.mobilePla')
                }, null, 8, ["modelValue", "placeholder"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, {
              prop: "email",
              label: _ctx.$t('CONFIG.labelEmail')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: formData.value.email,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formData.value.email) = $event)),
                  maxlength: "50",
                  placeholder: _ctx.$t('CONFIG.emailPla')
                }, null, 8, ["modelValue", "placeholder"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, {
              prop: "orgId",
              label: _ctx.$t('CONFIG.labelOrg')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_tree_select, {
                  disabled: "",
                  modelValue: formData.value.orgId,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((formData.value.orgId) = $event)),
                  data: orgList.value,
                  "render-after-expand": false,
                  "default-expand-all": "",
                  style: {"width":"100%"},
                  "check-strictly": ""
                }, null, 8, ["modelValue", "data"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, {
              prop: "roleId",
              label: _ctx.$t('CONFIG.labelRole')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: formData.value.roleId,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((formData.value.roleId) = $event)),
                  class: "ws_select",
                  placeholder: _ctx.$t('CONFIG.rolePla'),
                  disabled: _unref(disbaledRuleChange)
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(roleList.value, (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: item.value,
                        label: item.label,
                        value: item.value,
                        disabled: item.disabled
                      }, null, 8, ["label", "value", "disabled"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue", "placeholder", "disabled"])
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          _: 1
        }, 8, ["model"])
      ])), [
        [_directive_loading, detailLoading.value]
      ])
    ]),
    _: 1
  }, 8, ["model-value", "title"]))
}
}

})